import { supabase } from "@/integrations/supabase/client";

export interface VinDetectionResponse {
  vin?: string;
  error?: string;
}

export class ImageProcessingError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ImageProcessingError';
  }
}

export const processVinImage = async (file: File): Promise<VinDetectionResponse> => {
  console.log("Processing VIN image...");
  
  try {
    if (!file.type.startsWith('image/')) {
      throw new ImageProcessingError('Please upload an image file');
    }

    const formData = new FormData();
    formData.append("file", file);

    const { data: { publicUrl } } = supabase.storage
      .from('vin-images')
      .getPublicUrl('temp/' + file.name);

    console.log("Calling detect-vin function...");
    const { data, error } = await supabase.functions.invoke('detect-vin', {
      body: formData
    });

    if (error) {
      console.error("Function invocation error:", error);
      throw new ImageProcessingError(error.message);
    }

    console.log("VIN detection response:", data);

    if (data.vin) {
      return { vin: data.vin };
    } else if (data.error) {
      return { error: data.error };
    } else {
      return { error: "No VIN found in image" };
    }
  } catch (error) {
    console.error("Error processing VIN image:", error);
    if (error instanceof ImageProcessingError) {
      return { error: error.message };
    }
    return {
      error: "Failed to process image. Please try again.",
    };
  }
};